<template>
  <div v-loading="loading" class="approval-detail-page">
    <div class="rj-page-card">
      <div class="rj-page-card__title">
        申请基本信息
      </div>
      <div class="rj-page-card__content">
        <div class="baseInfoForm">
          <div class="rj-row">
            <div
              v-for="(item, index) in basicInfoItems"
              :key="index"
              :class="item.fullRow ? 'rj-col-1' : 'rj-col-3'"
            >
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  {{ item.label }}：
                </div>
                <div class="rj-baseinfo__item">
                  {{ formatEmpty(item.value) }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="rj-page-card section-gap">
      <div class="rj-page-card__title">
        产品行分摊明细
      </div>
      <div class="rj-page-card__content">
        <!-- <div class="summary-bar">
          <el-button type="primary">
            导出材料信息
          </el-button>
          <div class="summary-label">
            分摊行数:
          </div>
          <div class="summary-value">
            {{ contractDetailData.length || '-' }}
          </div>
        </div> -->
        <!-- 计算公式参考 -->
        <!-- 本地发票 -->
        <div v-if="detailData.sourceType === 2" class="formula-ref">
          <span class="formula-ref__title">计算公式参考：</span>
          返利金额 = (AR 正向总金额 <b>{{ formatAmount(formulaData.positiveArInvoiceTotalAmount) }}</b> + AR 负向总金额 <b>{{ formatAmount(formulaData.negativeArInvoiceTotalAmount) }}</b>) × {{ REBATE_RATIO }} - 已抵扣返利金额 <b>{{ formatAmount(formulaData.historicalDeductedAmount) }}</b> + 退回返利金额 <b>{{ formatAmount(formulaData.historicalReturnedAmount) }}</b>；年度确收金额 <b>{{ formatAmount(formulaData.annualConfirmedIncome) }}</b> × {{ REBATE_RATIO }}
        </div>
        <!-- 报关台账 -->
        <div v-if="detailData.sourceType === 1" class="formula-ref">
          <span class="formula-ref__title">计算公式参考：</span>
          返利金额 = (AR 正向总金额 <b>{{ formatAmount(formulaData.positiveArInvoiceTotalAmount) }}</b> + AR 负向总金额 <b>{{ formatAmount(formulaData.negativeArInvoiceTotalAmount) }}</b>) × {{ REBATE_RATIO }} - 已抵扣返利金额 <b>{{ formatAmount(formulaData.historicalDeductedAmount) }}</b> + 退回返利金额 <b>{{ formatAmount(formulaData.historicalReturnedAmount) }}</b>；年度确收金额 <b>{{ formatAmount(formulaData.annualConfirmedIncome) }}</b>
        </div>

        <el-table :data="contractDetailData" border style="width: 100%">
          <el-table-column type="index" label="序号" width="60" align="center" />
          <el-table-column prop="contractNo" label="合同编号" align="left" min-width="110" />
          <el-table-column prop="arInvoiceId" label="AR发票号" align="left" min-width="120" />
          <el-table-column prop="productName" label="产品名称" align="left" min-width="150" show-overflow-tooltip />
          <el-table-column prop="productCode" label="产品型号" align="left" min-width="120" show-overflow-tooltip />
          <el-table-column prop="quantity" label="数量" align="right" min-width="80" />
          <el-table-column prop="unitPrice" label="单价" align="right" min-width="90" />
          <el-table-column prop="historicalNetDeductedAmount" label="历史抵扣金额" align="right" min-width="120">
            <template v-slot="{ row }">
              <span class="amount-highlight">{{ row.rebateArAllocationDetail.historicalNetDeductedAmount }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="allocationAmount" label="本次抵扣金额" align="right" min-width="120">
            <template v-slot="{ row }">
              <span class="amount-highlight">{{ row.rebateArAllocationDetail.allocationAmount }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <div class="rj-page-card section-gap">
      <div class="rj-page-card__title">
        特批附件信息
      </div>
      <div class="rj-page-card__content">
        <el-table :data="attachments" border style="width: 100%">
          <el-table-column prop="fileName" label="文件名称" align="left" min-width="240" show-overflow-tooltip>
            <template v-slot="{ row }">
              <el-button type="text" class="el-btn-text-left" @click="handlePreview(row)">
                {{ row.fileName }}
              </el-button>
            </template>
          </el-table-column>
          <el-table-column prop="uploadedAt" label="上传时间" align="left" min-width="160" />
          <el-table-column prop="uploadedByName" label="上传人" align="left" min-width="160" />
          <el-table-column label="操作" align="left" width="100">
            <template v-slot="{ row }">
              <el-button type="text" @click="handlePreview(row)">
                查看
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <div class="rj-page-card section-gap">
      <div class="rj-page-card__title">
        商务审核意见
      </div>
      <div class="rj-page-card__content">
        <el-input
          v-model="approvalOpinion"
          type="textarea"
          :rows="4"
          :disabled="type === 'view'"
          maxlength="200"
          placeholder="请输入商务审核意见"
          show-word-limit
        />
      </div>
    </div>

    <div class="page-actions">
      <el-button @click="handleBack">
        返回
      </el-button>
      <el-button
        v-if="type === 'approval'"
        type="primary"
        plain
        :loading="rejectLoading"
        :disabled="rejectLoading"
        @click="handleReject"
      >
        驳回
      </el-button>
      <el-button
        v-if="type === 'approval'"
        type="primary"
        :loading="approveLoading"
        :disabled="approveLoading"
        @click="handleApprove"
      >
        通过
      </el-button>
    </div>
  </div>
</template>

<script>
import { GetRebateReceivableDetail, ApproveRebateReceivable, fileDownload } from '@/API/BatchManagement.js';

export default {
  data () {
    return {
      loading: false,
      rejectLoading: false,
      approveLoading: false,
      detailData: null,
      attachments: [],
      approvalOpinion: '',
      contractDetailData: null,
      REBATE_RATIO: 0.3, // 返利计提比例
      formulaData: {
        positiveArInvoiceTotalAmount: 0, // AR 正向总金额
        negativeArInvoiceTotalAmount: 0, // AR 负向总金额
        historicalReturnedAmount: 0, // 退回返利金额
        annualConfirmedIncome: 0, // 年度确收金额
        historicalDeductedAmount: 0 // 已抵扣返利金额
      }
    };
  },

  computed: {
    currentApplyNo () {
      return this.$route.params.contractNum;
    },
    type () {
      return this.$route.query.type || 'view';
    },
    tab () {
      return this.$route.query.tab || '3';
    },
    basicInfoItems () {
      const basicInfo = this.detailData || {};
      return [
        { label: '申请单号', value: basicInfo.applicationNo },
        { label: '申请日期', value: basicInfo.submittedAt },
        { label: '申请类型', value: basicInfo.sourceType === 1 ? '报关台账号' : '本地发票' },
        { label: '渠道编码', value: basicInfo.channelCode },
        { label: '渠道名称', value: basicInfo.channelName },
        { label: '合同编号', value: basicInfo.contractNo },
        { label: '业务实体', value: basicInfo.businessEntityName },
        { label: '币种', value: basicInfo.currency },
        { label: '申请抵扣金额', value: basicInfo.applicationAmount },
        { label: '申请人', value: basicInfo.applicantName },
        { label: '申请人账号', value: basicInfo.createdBy },
        { label: basicInfo.sourceType === 1 ? '报关台账号' : '本地发票号', value: basicInfo.sourceType === 1 ? basicInfo.customsAccount : basicInfo.localInvoiceNo },
        { label: '审批状态', value: this.getStatusText(basicInfo.status) }
      ];
    }
  },

  created () {
    this.initPageData();
  },

  methods: {
    async initPageData () {
      this.loading = true;
      try {
        const res = await GetRebateReceivableDetail(this.currentApplyNo);
        const { status, data } = res.data;
        if (Number(status) === 200) {
          this.formulaData = data.batch || {}; // 计算公式数据
          this.detailData = JSON.parse(JSON.stringify(data.application));
          this.contractDetailData = JSON.parse(JSON.stringify(data.products));
          this.attachments = JSON.parse(JSON.stringify(data.attachments || []));
          if (this.type === 'view' && data.operationRecords && data.operationRecords.length > 0) {
            this.approvalOpinion = data.operationRecords[data.operationRecords.length - 1].operationRemark || '';
          }
        }
      } catch (error) {
        this.$message.error('获取详情失败');
      } finally {
        this.loading = false;
      }
    },

    // 金额格式化：保留两位小数
    formatAmount (value) {
      if (value === undefined || value === null || value === '') return '';
      return Number(String(value).replace(/,/g, '')).toFixed(2);
    },

    getStatusText (status) {
      const statusList = [
        { label: '草稿', value: 0 },
        { label: '待商务审批', value: 1 },
        { label: '待抛 ERP', value: 2 },
        { label: '已抛 ERP', value: 4 },
        { label: '驳回', value: 5 },
        { label: '撤回', value: 6 },
        { label: 'ERP 处理失败', value: 7 }
      ];
      const statusItem = statusList.find(item => item.value === status);
      return statusItem ? statusItem.label : '-';
    },

    formatEmpty (value) {
      return value || '-';
    },

    async handlePreview (row) {
      if (!row.fileId) {
        this.$message.warning('附件不存在');
        return;
      }
      try {
        const res = await fileDownload(row.fileId);
        const responseData = res && res.data;
        // 后端报错时返回的是 JSON（已被拦截器转成对象），而非文件流
        if (!(responseData instanceof Blob)) {
          const message = (responseData && (responseData.err || responseData.error || responseData.msg)) || '附件下载失败';
          this.$message.error(message);
          return;
        }
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(responseData);
        link.download = row.fileName || 'download';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(link.href);
      } catch (error) {
        console.error(error);
        this.$message.error('附件下载失败，请稍后重试');
      }
    },

    handleBack () {
      this.$router.push({
        name: 'OverseasBatchPaymentManagement',
        query: { tab: this.tab }
      });
    },

    handleReject () {
      if (this.rejectLoading) {
        return;
      }
      if (!this.approvalOpinion) {
        this.$message.warning('请填写审批意见');
        return;
      }
      this.rejectLoading = true;
      ApproveRebateReceivable({
        applicationNo: this.detailData.applicationNo,
        approvalAction: 'REJECT',
        comment: this.approvalOpinion
      }).then(() => {
        this.$message.success(`操作成功`);
        this.$router.push({
          name: 'OverseasBatchPaymentManagement',
          query: { tab: this.tab }
        });
      }).catch(() => {
        this.$message.error('审批失败，请稍后重试。');
      }).finally(() => {
        this.rejectLoading = false;
      });
    },

    handleApprove () {
      if (this.approveLoading) {
        return;
      }
      this.approveLoading = true;
      ApproveRebateReceivable({
        applicationNo: this.detailData.applicationNo,
        approvalAction: 'APPROVE',
        comment: this.approvalOpinion || ''
      }).then(() => {
        this.$message.success(`操作成功`);
        this.$router.push({
          name: 'OverseasBatchPaymentManagement',
          query: { tab: this.tab }
        });
      }).catch(() => {
        this.$message.error('审批失败，请稍后重试。');
      }).finally(() => {
        this.approveLoading = false;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.approval-detail-page {
  padding-bottom: 24px;
}

.formula-ref {
  margin: 0 0 16px;
  padding: 10px 14px;
  border: 1px dashed #dce8ff;
  border-radius: 10px;
  background: #f6faff;
  font-size: 13px;
  line-height: 22px;
  color: #5b6575;
}

.formula-ref__title {
  font-weight: 600;
  color: #1f2d3d;
}

.formula-ref b {
  font-weight: 700;
  color: #0d6efd;
}

.section-gap {
  margin-top: 12px;
}

.baseInfoForm {
  .rj-baseinfo {
    min-height: 40px;
    margin-bottom: 10px;
    align-items: stretch;
  }
}

.approval-note-block {
  display: flex;
  align-items: flex-start;
}

.approval-note-text {
  line-height: 22px;
  color: #606266;
}

.summary-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  padding: 0 0 12px;
  font-size: 13px;
  color: #606266;
}

.summary-tag {
  padding: 4px 10px;
  border-radius: 2px;
  background: #409eff;
  color: #fff;
  line-height: 20px;
}

.summary-label {
  margin-left: 18px;
}

.summary-value {
  margin-left: 8px;
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  line-height: 28px;
}

.amount-highlight {
  color: #409eff;
  font-weight: 600;
}

.page-actions {
  display: flex;
  justify-content: flex-start;
  margin-top: 16px;
}

.page-actions .el-button + .el-button {
  margin-left: 10px;
}
</style>
